import { RESERVED_KEYWORDS } from '../types/automation';

/**
 * Validates if a column name is valid for user-defined columns
 */
export const isValidColumnName = (
  fieldName: string
): { valid: boolean; error?: string } => {
  if (RESERVED_KEYWORDS.includes(fieldName.toLowerCase())) {
    return {
      valid: false,
      error: `${fieldName} is a reserved keyword for internal use and may not be used as a column name`
    };
  }
  if (fieldName.startsWith('_')) {
    return {
      valid: false,
      error:
        'Column names starting with underscore are reserved for internal use'
    };
  }
  return { valid: true };
};
